import React, { useContext, useEffect, useState } from "react";
import { ethers } from "ethers";
import { ProjectContext } from "../../ProjectContext";
import { useAccount } from "wagmi";
import { TfiReload } from "react-icons/tfi";

function HistoryTable() {
  const { account, esigner, settings, DailReawardCap, dbuser, Maincontract, getFormattedDate } = useContext(ProjectContext);
  const [Data, setData] = useState([]);
  const { isConnected } = useAccount();
  const [ustat, setUstate] = useState(1);
  const [usercapping, setUcappingdate] = useState(null);

  const getData = async () => {
    console.log("tnx");

    if (!isConnected || !settings.token || esigner === null || !settings.contract) return;

    // Call contract to fetch user data
    const getUser = await Maincontract.getuserstakings(account);
    console.log("getUser123", getUser);

    
    // User Capping
    const timestamp = Math.floor(Date.now() / 1000);
    console.log("D", timestamp);
    const getUsercapping = await Maincontract.capping(account, timestamp);
    console.log("getUsercapping", getUsercapping);


    if ((new Date().toISOString() > getFormattedDate(getUsercapping[3].toString()))) {
      setUstate(0);

      setUcappingdate(new Date(parseInt(getUsercapping[3]._hex, 16) * 1000));
    }

    // Ensure getUser is not empty
    if (!getUser || getUser.length === 0) {
      console.error("No user data found for address:", account);
      setData([]);  // Set an empty array if no data
      return;
    }

    // Format and structure the data
    const userData = getUser.map(item => ({
      address: item[1],
      amount: Number(ethers.utils.formatUnits(item[2], 6)).toFixed(0),
      dailyroi: ethers.utils.formatUnits(item[3], 18),
      dailyreward: Number(ethers.utils.formatUnits(item[4], 6)) + Number(DailReawardCap),
      levelreward: ethers.utils.formatUnits(item[6], 6),
      extrareward: ethers.utils.formatUnits(item[6], 6),
      startdate: new Date(parseInt(item[8]._hex, 16) * 1000), // Convert timestamp to Date
      enddate: new Date(parseInt(item[9]._hex, 16) * 1000), // Convert timestamp to Date
      cappingdate: new Date(parseInt(item[10]._hex, 16) * 1000), // Convert timestamp to Date
      token: ethers.utils.formatUnits(item[11], 18), // Convert timestamp to Date
      status: parseInt(item[12].toString()), // Assuming status is an integer (0 or 1)
    }));

    const sortedUserData = userData.sort((a, b) => b.startdate - a.startdate);

    setData(sortedUserData);  // Set the data state with sorted user data
  };

  useEffect(() => {
    if (dbuser?.address.toLowerCase() === account?.toLowerCase()) {
      getData();
    }
  }, [dbuser, account]);

  return (
    <div>
      {" "}
      <table className="table">
        <tbody>
          <tr>
            <td className="text-end border-0" colSpan={4}>
              <button className="text-white btn btn-outline-bg-new-primary py-2 px-3" onClick={() => getData()} ><TfiReload /></button>
            </td>
          </tr>
          <tr className="table-header">
            <th className="cell">S.NO</th>
            <th className="cell">AMOUNT</th>
            <th className="cell">DATE</th>
            <th className="cell">STATUS</th>
          </tr>
          {Data.length > 0 ? (
            Data.map((user, index) => (
              <tr key={index}>
                <td><strong>{index + 1}</strong></td>
                {/* <td>{formatAddress(user.address)}</td> */}
                <td>$ {user.amount}</td>
                <td>
                  Start : {user?.startdate.toLocaleString()}
                  <br />
                  End : {ustat === 1 ? user?.enddate.toLocaleString() : usercapping?.toLocaleString()}
                </td>
                <td>
                  {(user?.status === 1) ?
                    ustat === 1 ?
                      <span className={"badge light badge-success"}>
                        Active
                      </span>
                      :
                      <span className={"badge light badge-danger"}>
                        Inactive
                      </span>
                    :
                    <span className={"badge light badge-danger"}>
                      Inactive
                    </span>
                  }
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8" className="text-center">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
}

export default HistoryTable;
